import green from "@material-ui/core/colors/green";
import lightGreen from "@material-ui/core/colors/lightGreen";
import grey from "@material-ui/core/colors/grey";
import red from "@material-ui/core/colors/red";
import pink from "@material-ui/core/colors/pink";
import deepOrange from "@material-ui/core/colors/deepOrange";
import { Typography, Button, IconButton, Tooltip,Chip } from "@material-ui/core";
//material-ui.com/style/color/
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EmailIcon from "@material-ui/icons/Email";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ScheduleIcon from "@material-ui/icons/Schedule";


export function getParticipantColor(participant) {
	// entweder Teilnehmer/in hat die Anmeldung zurückgezogen oder die E-Mail (noch) nicht bestätigt.
	// Während die E-Mails auf Bestätigungwarten sind demnach sehr viele Teilnehmer in dieser Farbe
	if (
		participant.status == "canceled" ||
		participant.status == "invited" ||
		participant.status == "later_acceptance_sent"
	)
		return deepOrange[100];

	// Teilnehmer hat eine Absage erhalten
	if (participant.status == "rejected") return red[100];

	// Teilnehmer mit drei Sternen oder Status Nachnominiert (Vorgemerkt oder bestätigt)
	if (
		participant.rating == 3 ||
		participant.status == "for_later_acceptance" ||
		participant.status == "later_acceptance_confirmed"
	)
		return lightGreen[100];

	// Teilnehmer mit nur einem Stern
	if (participant.rating == 1) return pink[100];

	// Teilnehmer mit zwei Sternen
	if (participant.rating == 2) return grey[200];

	// Teilnehmer mit vier Sternen
	if (participant.rating == 4) return green[100];

	return "#FFFFFF";
}

export function isParticipantGreen(participant) {
	if (!participant) return false;

	const participant_color = getParticipantColor(participant);

	const colors = {
		green: Object.values(green),
		lightGreen: Object.values(lightGreen)
	};

	return (
		colors.green.indexOf(participant_color) > -1 ||
		colors.lightGreen.indexOf(participant_color) > -1
	);
}

export function getColorDescription(color) {
	const descriptions = {
		green: "Teilnehmer mit vier Sternen",
		lightGreen: "Teilnehmer mit drei Sternen oder Status Nachnominiert",
		grey: "Teilnehmer mit zwei Sternen",
		pink: "Teilnehmer mit nur einem Stern",
		red: "Teilnehmer hat eine Absage erhalten",
		white: "Noch nicht klassifizierte Teilnehmer",
		deepOrange:
			"entweder Teilnehmer/in hat die Anmeldung zurückgezogen oder die E-Mail (noch) nicht bestätigt. Während die E-Mails auf Bestätigung warten sind demnach sehr viele Teilnehmer in dieser Farbe"
	};
	if (color in descriptions) return descriptions[color];
	return "";
}

// gibt den KEY (accessor) der Spalte für die Anrede zurück
export function getTitleColumnKey(participant_columns) {
	for (var i = 0; i < participant_columns.length; i++) {
		if (
			participant_columns[i].Header == "Anrede" ||
			participant_columns[i].accessor.indexOf("anrede") > -1
		) {
			return participant_columns[i].accessor;
		}
	}

	return false;
}

// return "m"/"f"/"u"
export function getParticipantGender(
	participant,
	title_column_key,
	icon_class_name
) {
	if (title_column_key && participant[title_column_key].toUpperCase() == "FRAU")
		return icon_class_name ? (
			<svg className={icon_class_name} viewBox="0 0 24 24">
				<path
					fill="#000000"
					d="M12,4A6,6 0 0,1 18,10C18,12.97 15.84,15.44 13,15.92V18H15V20H13V22H11V20H9V18H11V15.92C8.16,15.44 6,12.97 6,10A6,6 0 0,1 12,4M12,6A4,4 0 0,0 8,10A4,4 0 0,0 12,14A4,4 0 0,0 16,10A4,4 0 0,0 12,6Z"
				/>
			</svg>
		) : (
			"f"
		);
	else if (
		title_column_key &&
		participant[title_column_key].toUpperCase() == "HERR"
	)
		return icon_class_name ? (
			<svg className={icon_class_name} viewBox="0 0 24 24">
				<path
					fill="#000000"
					d="M9,9C10.29,9 11.5,9.41 12.47,10.11L17.58,5H13V3H21V11H19V6.41L13.89,11.5C14.59,12.5 15,13.7 15,15A6,6 0 0,1 9,21A6,6 0 0,1 3,15A6,6 0 0,1 9,9M9,11A4,4 0 0,0 5,15A4,4 0 0,0 9,19A4,4 0 0,0 13,15A4,4 0 0,0 9,11Z"
				/>
			</svg>
		) : (
			"m"
		);
	return icon_class_name ? (
		<svg className={icon_class_name} viewBox="0 0 24 24">
			<path
				fill="#000000"
				d="M17.58,4H14V2H21V9H19V5.41L15.17,9.24C15.69,10.03 16,11 16,12C16,14.42 14.28,16.44 12,16.9V19H14V21H12V23H10V21H8V19H10V16.9C7.72,16.44 6,14.42 6,12A5,5 0 0,1 11,7C12,7 12.96,7.3 13.75,7.83L17.58,4M11,9A3,3 0 0,0 8,12A3,3 0 0,0 11,15A3,3 0 0,0 14,12A3,3 0 0,0 11,9Z"
			/>
		</svg>
	) : (
		"u"
	);
}

export function validateEmail(email) {
	var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
	return re.test(String(email).toLowerCase());
}

export function validatePhoneNumber(phonenumber) {
	var re = /^[+0][ |\d]*$/g;
	return re.test(String(phonenumber));
}

export function printFiles(
	participant,
	accessor,
	readonly,
	show_as_icon = false
) {
	if (participant[accessor]) {
		const files = participant[accessor];
		return (
			<Typography variant="body1">
				{files.map(file => {
					if (show_as_icon)
						return (
							<Tooltip title={file.filename} key={file.id}>
								<IconButton
									color="primary"
									href={file.url}
									target="_blank"
									size="small"
								>
									<InsertDriveFileIcon />
								</IconButton>
							</Tooltip>
						);
					return (
						<Button
							key={file.id}
							href={file.url}
							target="_blank"
							variant="outlined"
							size="small"
						>
							{file.filename}
						</Button>
					);
				})}
			</Typography>
		);
	}
	return <div />;
}

export const status_choice = {
	new: {
		display_name: "Neu",
		icon: <FiberNewIcon/>
	},
	invited: {
		display_name: "Einladung gesendet",
		icon: <EmailIcon />
	},
	confirmed: {
		display_name: "Bestätigt",
		icon: <CheckCircleIcon />
	},
	rejected: {
		display_name: "Abgesagt",
		icon: <NotInterestedIcon />
	},
	guest: {
		display_name: "Gast",
		icon: <SupervisedUserCircleIcon />
	},
	guest_invited: {
		display_name: "Gast Einladung gesendet",
		icon: (
			<>
				<EmailIcon style={{ fontSize: 20 }}/>
				<SupervisedUserCircleIcon style={{ fontSize: 20 }}/>
			</>
		)
	},
	guest_confirmed: {
		display_name: "Gast Bestätigt",
		icon: (
			<>
				<CheckCircleIcon style={{ fontSize: 20 }}/>
				<SupervisedUserCircleIcon style={{ fontSize: 20 }}/>
			</>
		)
	},
	for_later_acceptance: {
		display_name: "Zur Nachnominierung vorgemerkt",
		icon: <AutorenewIcon />
	},
	later_acceptance_sent: {
		display_name: "Nachnominierung gesendet",
		icon: (
			<React.Fragment>
				<EmailIcon style={{ fontSize: 20 }}/>
				<AutorenewIcon style={{ fontSize: 20 }}/>
			</React.Fragment>
		)
	},
	later_acceptance_confirmed: {
		display_name: "Nachnominierung bestätigt",
		icon: (
			<React.Fragment>
				<CheckCircleIcon style={{ fontSize: 20 }}/>
				<AutorenewIcon style={{ fontSize: 20 }}/>
			</React.Fragment>
		)
	},
	quickcheckin: {
		display_name: "last minute",
		icon: <ScheduleIcon />
	},
	canceled: {
		display_name: "Anmeldung zurückgezogen",
		icon: <NotInterestedIcon />
	},
	not_appeared: {
		display_name: "nicht erschienen",
		icon: <CancelIcon />
	}
};


export const printParticipantCompanyJobPositions = (participant, company_index, jobpositions, classes) => {
	const position_ids = participant["company_" + company_index + "_jobpositions"] ? participant["company_" + company_index + "_jobpositions"] : [];
	const participant_positions = [];
	jobpositions.filter(pos => position_ids.includes(pos.ID)).forEach(pos => {
		let parentName = "";
		if (pos.parent > 0) {
			const parentPosition = jobpositions.find(parent => parent.ID === pos.parent);
			if (parentPosition)
				parentName = parentPosition.name + " > ";
		}
		participant_positions.push(
			<Tooltip key={pos.ID} title={parentName + pos.name}>
				<Chip
					size="small"
					label={pos.name}
					className={classes.positionChip}
				/>
			</Tooltip>)
	})
	if (position_ids.includes(-1)) {
		participant_positions.push(
			<Tooltip key={-1} title={"Initiativ: " + participant["company_" + company_index + "_customjobposition"]}>
				<Chip
					size="small"
					label={"Initiativ: " + participant["company_" + company_index + "_customjobposition"]}
					className={classes.positionChip}
				/>
			</Tooltip>)
	}
	return (
		<div key={"jobpositions-"+company_index} className={classes.positions}>
			{participant_positions}
		</div>
	);
};


export const printParticipantCompanyJobPositionsTooltip = (participant, companyId, jobpositions) => {
	let company_index = 0;
	for (let i = 1; i < 8; i++){
		if (parseInt(participant["company_" + i]) === parseInt(companyId) ) {
			company_index = i;
			break;
		}
	}
	if (!company_index)
		return null;

	const position_ids = participant["company_" + company_index + "_jobpositions"];
	const participant_positions = [];
	jobpositions.filter(pos => position_ids.includes(pos.ID)).forEach(pos => {
		let parentName = "";
		if (pos.parent > 0) {
			const parentPosition = jobpositions.find(parent => parent.ID === pos.parent);
			if (parentPosition)
				parentName = parentPosition.name + " > ";
		}
		participant_positions.push(<div>{parentName + pos.name}</div>)
	})
	if (position_ids.includes(-1)) {
		participant_positions.push(<div>Initiativ: {participant["company_" + company_index + "_customjobposition"]}</div>);
	}
	return <>{participant_positions}</>;
};
